var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.225 4.21016L8.5 7.47991L15.775 4.21016M8.5 14V7.47344M16 10.0633V4.88353C15.9997 4.65644 15.9225 4.43341 15.7763 4.23681C15.63 4.0402 15.4198 3.87694 15.1667 3.7634L9.33333 1.17349C9.07997 1.05983 8.79256 1 8.5 1C8.20744 1 7.92003 1.05983 7.66667 1.17349L1.83333 3.7634C1.58022 3.87694 1.36998 4.0402 1.22372 4.23681C1.07745 4.43341 1.0003 4.65644 1 4.88353V10.0633C1.0003 10.2904 1.07745 10.5135 1.22372 10.7101C1.36998 10.9067 1.58022 11.0699 1.83333 11.1835L7.66667 13.7734C7.92003 13.887 8.20744 13.9469 8.5 13.9469C8.79256 13.9469 9.07997 13.887 9.33333 13.7734L15.1667 11.1835C15.4198 11.0699 15.63 10.9067 15.7763 10.7101C15.9225 10.5135 15.9997 10.2904 16 10.0633Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCount);
export default __webpack_public_path__ + "static/media/count.6a307b79806612af2ae7594ca60be7f5.svg";
export { ForwardRef as ReactComponent };